import React, { Fragment, MouseEvent } from "react";
import { logout } from "../../../../helpers/auth";
import { ROUTES } from "../../../../routes";
import { useCurrentUser } from "../../../../store/current-user";
import Link from "../../../elements/link";
import AccordionProvider, { Accordion, AccordionToggler } from "../../../nbc-ui/accordion";
import Space from "../../../Space";

export default function HeaderTopArea(): React.JSX.Element {
  const [currentUser, , /*fetchCurrentUser*/, setCurrentUser] = useCurrentUser();

  /*useEffect(() => {
    fetchCurrentUser();
  }, []);*/

  function handleLogoutButtonClick(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    logout({ onLogoutSuccess: function onLogoutSuccess() {
      setCurrentUser(null);
    }});
  }

  return (
    <div className="header-top">
      <div className="container">
        <div className="row">
          {/* Begin Header Top Left Area */ }
          <div className="col-lg-3 col-md-4">
            <div className="header-top-left">
              <ul className="phone-wrap">
                <li>
                  <span>Telephone Enquiry:</span>
                  <Space />
                  <a href="#">{process.env.SUPPORT_PHONE_NUMBER}</a>
                </li>
              </ul>
            </div>
          </div>
          {/* Header Top Left Area End Here */}

          {/* Begin Header Top Right Area */}
          <div className="col-lg-9 col-md-8">
            <div className="header-top-right">
              <ul className="ht-menu">
                {/* Begin Setting Area * /}
                { currentUser && 
                  <li>
                    <div className="ht-setting-trigger">
                      <span>Setting</span>
                    </div>
                    <div className="setting ht-setting">
                      <ul className="ht-setting-list">
                        <li><a href="login-register.html">My Account</a></li>
                        <li><a href="checkout.html">Checkout</a></li>
                      </ul>
                    </div>
                  </li>
                }
                {/* Setting Area End Here */}

                {/* Begin Currency Area * /}
                <li>
                  <span className="currency-selector-wrapper">Currency :</span>
                  <div className="ht-currency-trigger">
                    <span>USD $</span>
                  </div>
                  <div className="currency ht-currency">
                    <ul className="ht-setting-list">
                      <li><a href="#">EUR €</a></li>
                      <li className="active"><a href="#">USD $</a></li>
                    </ul>
                  </div>
                </li>
                {/* Currency Area End Here */}

                {/* Begin Language Area * /}
                <li>
                  <span className="language-selector-wrapper">Language :</span>
                  <div className="ht-language-trigger">
                    <span>English</span>
                  </div>
                  <div className="language ht-language">
                    <ul className="ht-setting-list">
                      <li className="active"><a href="#"><img src="images/menu/flag-icon/1.jpg" alt="" />English</a></li>
                      <li><a href="#"><img src="images/menu/flag-icon/2.jpg" alt="" />Français</a></li>
                    </ul>
                  </div>
                </li>
                {/* Language Area End Here */}

                { currentUser && 
                  <Fragment>
                    <li style={{ color: "var(--gray)", fontSize: "14.5px" }}>
                      <span>Welcome {currentUser.firstname}</span>
                    </li>

                    <li>
                      <AccordionProvider>
                        <div className="ht-setting-trigger">
                          <AccordionToggler>Account</AccordionToggler>
                        </div>
                        <Accordion className="setting ht-setting">
                          <ul className="ht-setting-list">
                            <li><Link to={ROUTES.ORDER_LISTING}>My Orders</Link></li>
                            <li><Link to={ROUTES.WISHLIST}>My Saved Items</Link></li>
                          </ul>
                        </Accordion>
                      </AccordionProvider>
                    </li>

                    <li>
                      <a href="#" onClick={handleLogoutButtonClick} title="Logout">
                        <i className="fa fa-power-off" aria-hidden="true"></i>
                      </a>
                    </li>
                  </Fragment>
                }

                { !currentUser && 
                  <li>
                    Welcome, 
                    <Space />
                    <Link to={ROUTES.SIGNIN} end>login</Link> or 
                    <Space />
                    <Link to={ROUTES.SIGNUP} end>sign up</Link>
                  </li>
                }
              </ul>
            </div>
          </div>
          {/* Header Top Right Area End Here */}
        </div>
      </div>
    </div>
  )
}
